import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Toaster from "../../components/Toaster/Toaster";
import styles from "./LandingPage.module.scss";
import "react-toastify/dist/ReactToastify.css";
import ewallet from "../../resources/images/eWallet_logo.svg";
import cc from "../../resources/images/CC.svg";
import squiggle from "../../resources/images/sqiggly.svg";
import infoicon from "../../resources/images/infoicon.svg";
import useMakeSession from "../../hooks/useMakeSession";
import useGetSession from "../../hooks/useGetSession";
import analyticsService from "../../services/analytics/analyticsService";
import bookfair from "../../interfaces/bookfair-info";
import ExternalLogin from "../../components/ExternalLogin/ExternalLogin";
import constants from "../../constants/constants";
import LandingPageHeader from "../../components/LandingPageHeader/LandingPageHeader";

function LandingPage(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const fairId = props.fairId;
  const [mySession] = useMakeSession();
  const [getSession] = useGetSession();
  const [bookfairInfo, setBookfairInfo] = useState<bookfair>();
  const env = process.env.REACT_APP_BF;

  let dumble = new analyticsService();

  useEffect(() => {
    if (location.state !== null) {
      const timeout = setTimeout(() => {
        navigate("/");
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [location.state]);           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
  useEffect(() => {
    getSessionInfo();
  }, []);

  // init analytics
  useEffect(() => {
    dumble.initDumblePage("Payment Portal: Select Method");
  }, [])

  // fill info with session info
  const getSessionInfo = async () =>{
    const { data, error } = await getSession();

    if (error){
      console.log(error);
      createSessionInfo();
      return;
    } else if (data != null) {
      const info = {
        school: data.school.name,  
        startDate: data.fair.deliveryDate,
        endDate: data.fair.pickupDate,
        id: data.fair.id,

        ccSales: data.sales.cc,
        ewalletSales: data.sales.ewallet,
        totalSales: data.sales.total,
        stfSales: data.sales.stf,
      }
      setBookfairInfo(info);
    }
  }

 // request session with signed fields 
 // creates cookie after we already signed in from another site
  const createSessionInfo = async () =>{
    const { data, error } = await mySession(fairId);
    if (error){
      console.log(error);
      localStorage.removeItem("loggedIn");
      if (error.errorMessage && (error.errorMessage.toLowerCase() === "invalid fair" ||
          error.errorMessage.toLowerCase() === "fairid should be provided")){
        window.location.replace(`${env}${constants.bf}`);
      }
    } else if (data != null) {
      localStorage.loggedIn = true;

      const info = {
        school: data.school.name,  
        startDate: data.fair.deliveryDate,
        endDate: data.fair.pickupDate,
        id: data.fair.id,

        ccSales: data.sales.cc,
        ewalletSales: data.sales.ewallet,
        totalSales: data.sales.total,
        stfSales: data.sales.stf,
      }
      setBookfairInfo(info);
    }
  }

  const titleCase = (name: string) => {
    name = name.toLowerCase();
    const temp = name.split(' ');
    for (var i = 0; i < temp.length; i++) {
      temp[i] = temp[i].charAt(0).toUpperCase() + temp[i].slice(1); 
    }
    name = temp.join(' ');
    return name;
  }

  const fillBookFairInfo = (fairId: any) => {
    setBookfairInfo(fairId);
  }

  const reformatDates = (date: string) => {
    return `${date.substring(5, 7)}/${date.substring(8, date.length)}/${date.substring(2, 4)}`;
  }

  const schoolData = () => {
    if (bookfairInfo){
      return ( 
        <div className={styles.heading}>
          <div className={styles.school}>
            {titleCase(bookfairInfo.school)}
          </div>
          <h5> 
            {reformatDates(bookfairInfo.startDate)} - {reformatDates(bookfairInfo.endDate)}</h5>
          <h5>
            Book Fair ID:
            {" "}
            {bookfairInfo.id}
          </h5>
        </div>
      )
    }
  };

  const displayToast = () => {
    if (location.state === null) {
      return null;
    }
    return <Toaster info={location.state} />;
  };

  const loadBfInfo = () => {
    // means there is stuff (cookies)
    if (bookfairInfo){
      return(
    
        <div className={styles.LandingPage} data-testid="LandingPage">
          {displayToast()}
          <LandingPageHeader/>
          <div className={styles.body}>

            <div className={styles.info}>
              {schoolData()}
              <img src = {squiggle} className={styles.squiggle}/>
              <div className = {styles.sales}>
                  <div>
                    <h5>Credit Card Sales</h5>
                    <h3>${bookfairInfo.ccSales.toFixed(2)}</h3>
                  </div>
                  <div>
                    <h5>eWallet Sales</h5>
                    <h3>${bookfairInfo.ewalletSales.toFixed(2)}</h3>
                  </div>
                  <div>
                    <h5>Total Sales</h5>
                    <h3><b>${bookfairInfo.totalSales.toFixed(2)}</b></h3>
                  </div>
                  <hr className={styles.linebreak} />
                  <div>
                    <h5>Share The Fair Funds</h5>
                    <h3><b>${bookfairInfo.stfSales.toFixed(2)}</b></h3>
                  </div>
                </div>

              </div>
            <div className={styles.allButtons}>
              <button type="button" className={styles.button} 
                onClick={() => navigate("/creditcardpayment.html")}>
                <img src={cc} alt="credit card" className={styles.svgCC} />
                <div className={styles.buttonnames}>
                  Process
                  <br />
                  Credit Card
                  <br />
                  Payment
                </div>
              </button>
              <button type="button" className={styles.button} onClick={() => navigate("/ewalletpayment.html")}>
                <img src={ewallet} alt="ewallet" className={styles.svgEwallet} />
                <div className={styles.buttonnames}>
                  Process
                  <br />
                  eWallet
                  <br />
                  Payment
                </div>
              </button>
              <button type="button" className={`${styles.button} ${styles.nopicbutton}`} 
                onClick={() => navigate("/sharethefair.html", {state: {school: titleCase(bookfairInfo.school), stfFunds: bookfairInfo.stfSales.toFixed(2)}})}>
                <div className={styles.buttonnames}>
                  Redeem Share the Fair Funds
                </div>
              </button>
              <button type="button" className={`${styles.button} ${styles.nopicbutton}`} onClick={() => navigate("/ewalletrefund.html")}>
                <div className={styles.buttoncenter}>
                  eWallet Refund
                </div>
              </button>
              <div className={styles.creditRefund}>
                <div>
                  Credit Card Refund 
                </div>
                <div className={styles.tooltip}>
                  <img src={infoicon} alt="infoicon"/>
                  <div className={styles.tooltiptext}>
                  To complete a credit card refund, please call <br/> 1-888-412-9124 
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      )
      // not logged in :(
    } else if ((!localStorage.loggedIn && localStorage) || localStorage.length === 0){
      return(
        <div className={styles.LandingPage} data-testid="LandingPage">
          <ExternalLogin fairId={props.fairId} handleInfo={fillBookFairInfo}/>
        </div>
      ) 
    } 
  }

  return (
    <>
      {loadBfInfo()}
    </>
  );
}

export default LandingPage;
